import React from 'react';
import { getValidVariant } from '../_utils';
var ROUND_PRECISION = 1000;
var ProgressBarItem = function (props) {
    var _a = props.min, min = _a === void 0 ? 0 : _a, _b = props.max, max = _b === void 0 ? 100 : _b, label = props.label, value = props.value, showValue = props.showValue, variant = props.variant, animated = props.animated, striped = props.striped, height = props.height, className = props.className;
    var getValidValue = function (value) {
        if (value === null || value === '')
            return 0;
        return value > max ? max : value < 0 ? 0 : value;
    };
    var getPercentage = function (value, min, max) {
        var percentage = ((value - min) / (max - min)) * 100;
        return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
    };
    var getClassName = function () {
        var className = 'progress-bar';
        if (animated)
            className += ' progress-bar-animated';
        if (striped || animated)
            className += ' progress-bar-striped';
        if (variant)
            className += " bg-" + getValidVariant(variant);
        return className;
    };
    var validValue = getValidValue(value);
    return (React.createElement("div", { role: "progressbar", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": validValue, className: "" + getClassName() + (className ? " " + className : ''), style: {
            width: getPercentage(validValue, min, max) + "%",
            height: height ? height : 'inherit'
        } }, showValue && (label ? label : "" + validValue.toFixed(0))));
};
export default React.memo(ProgressBarItem);
